<template>
  <v-tooltip open-delay="100" right>
    <template v-slot:activator="{ on }">
      <div v-on="on" style="font-size: small">
        {{ item.name }}
      </div>
    </template>
    <span>{{ item.description }}</span>
  </v-tooltip>
</template>

<script>
export default {
  name: "ValidationLabel",

  props: {
    item: {
      type: Object,
      required: true
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/Home/Content/Tabs/Validations/ValidationSelection/ValidationLabel.vue